import { SVGAttributes } from "react";

export const ABIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" | "regular" }
) => {
  if (props.size === "small") {
    return (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.632 7.36l.528 2.016h1.704v5h3.216c.8 0 1.42-.208 1.86-.624.448-.416.672-.976.672-1.68 0-.568-.144-1.012-.432-1.332-.28-.32-.68-.544-1.2-.672v-.072c.44-.128.776-.332 1.008-.612.24-.288.36-.672.36-1.152 0-.688-.22-1.232-.66-1.632-.432-.4-1.06-.6-1.884-.6h-2.94v2.578L6.812 1H4.268L2 9.376h1.824L4.34 7.36h2.292zM5.444 2.74h.096l.816 3.168H4.628l.816-3.168zm7.032 10.16c-.2.144-.516.216-.948.216h-.912v-2.364h.912c.432 0 .748.072.948.216.2.144.3.408.3.792v.348c0 .384-.1.648-.3.792zm-.252-3.552c-.192.136-.5.204-.924.204h-.684V7.26h.684c.424 0 .732.068.924.204.192.136.288.388.288.756v.36c0 .368-.096.624-.288.768z"
          fill="currentColor"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.224 10.192l.848 2.976h1.904L9.712 2H7.264L4 13.168h1.824l.848-2.976h3.552zm-1.84-6.384h.128l1.376 4.896h-2.88l1.376-4.896zM16.864 10h-3.856v11.168h4.288c.47 0 .896-.075 1.28-.224a3 3 0 001.008-.656 3.01 3.01 0 00.64-1.008 3.46 3.46 0 00.224-1.264c0-.768-.197-1.36-.592-1.776-.395-.427-.917-.715-1.568-.864v-.08c.544-.16.976-.432 1.296-.816.32-.384.48-.901.48-1.552 0-.907-.283-1.621-.848-2.144-.555-.523-1.339-.784-2.352-.784zm1.264 9.424c-.32.245-.779.368-1.376.368h-1.984v-3.68h1.984c.597 0 1.056.123 1.376.368.32.245.48.64.48 1.184v.576c0 .544-.16.939-.48 1.184zm-.352-4.944c-.288.213-.715.32-1.28.32h-1.728v-3.424h1.728c.565 0 .992.112 1.28.336.299.213.448.576.448 1.088v.576c0 .512-.15.88-.448 1.104z"
          fill="currentColor"
        />
      </svg>
    );
  }
};
ABIcon.displayName = "ABIcon";
